<template>
  <div class="loading-animation">
    <LottieAnimation :animation-data="spinningHub" :auto-play="true" :loop="true" :speed="1" ref="lottieAnimation" class="lottie-image" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import LottieAnimation from 'lottie-web-vue';
import SpinningHub from '@/assets/spinning-hub.json';
import { AnimationItem } from 'lottie-web';

// Lottie Documentation: https://www.npmjs.com/package/lottie-web-vue
@Component({
  name: 'loading-animation',
  components: {
    LottieAnimation,
  },
})
export default class LoadingAnimation extends Vue {
  private lottieAnimation: AnimationItem | null = null;
  public spinningHub = SpinningHub;

  mounted() {
    this.$nextTick(() => {
      this.lottieAnimation = this.$refs.lottieAnimation as unknown as AnimationItem;
      setTimeout(() => {
        if (this.lottieAnimation && this.lottieAnimation.goToAndPlay) {
          this.lottieAnimation.goToAndPlay(150, true);
        }
      }, 500);
    });
  }
}
</script>

<style src="./loading-animation.component.scss" lang="scss"></style>
